import Helpers from "../../utils/helpers";
import { useTranslation } from "react-i18next";
 
const OrderReviewTotal = (props: any) => {
  const { t } = useTranslation();
 
 
  if (!props.orderedItems) {
    return null;
  }
 
  return (
    <div className="flex align-items-left justify-content-between px-3">
      <div className="col md:col-6 lg:col-6 ml-1">
        <label>Comments: </label>
        <label>{props.orderedItems?.props?.orderinfo?.comment || "No comments"}</label>
      </div>
      <div className="col col-1"></div>
      <div className="col-6 md:col-6 lg:col-3">
        <p className="m-1" style={{ lineHeight: "1.5" }}>
          {t("ordersummary_total_items_cost")} :
        </p>
        <p className="m-1" style={{ lineHeight: "1.5" }}>
          Total Tax :
        </p>
        <p className="m-1" style={{ lineHeight: "1.5" }}>
          Courier Charges :
        </p>
        {props.orderedItems?.props?.orderinfo?.discountAmount > 0 && (
          <p className="m-1" style={{ lineHeight: "1.5" }}>
            Discount :
          </p>
        )}
        <p
          className="m-1 font-semibold text-green font-bold"
          style={{ lineHeight: "1.5" }}
        >
          {t("ordersummary_total")} :
        </p>
      </div>
      <div className="col-6 md:col-6 lg:col-2 text-right">
        <p className="m-1" style={{ lineHeight: "1.5" }}>
          {Helpers.formatAmountInINR(props.orderedItems?.props?.orderinfo?.totalCost || 0)}
        </p>
        <p className="m-1" style={{ lineHeight: "1.5" }}>
          {Helpers.formatAmountInINR(props.orderedItems?.props?.orderinfo?.taxAmount || 0)}
        </p>
        <p className="m-1" style={{ lineHeight: "1.5" }}>
          {Helpers.formatAmountInINR(props.orderedItems?.props?.orderinfo?.courierCharges || 0)}
        </p>
        {props.orderedItems?.props?.orderinfo?.discountAmount > 0 && (
          <p className="m-1" style={{ lineHeight: "1.5" }}>
            {Helpers.formatAmountInINR(props.orderedItems?.props?.orderinfo?.discountAmount)}
          </p>
        )}
        <p
          className="m-1 font-semibold text-green font-bold"
          style={{ lineHeight: "1.5" }}
        >
          {Helpers.formatAmountInINR(Math.round(props.orderedItems?.props?.orderinfo?.discountAmount > 0 ? props.orderedItems?.props?.orderinfo?.total - props.orderedItems?.props?.orderinfo?.discountAmount : props.orderedItems?.props?.orderinfo?.total))}
        </p>
      </div>
    </div>
  );
};
 
export default OrderReviewTotal;
 